import { render } from "./CategoryItem.vue?vue&type=template&id=1901fb29"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"

import "./CategoryItem.vue?vue&type=style&index=0&id=1901fb29&lang=css"
script.render = render

export default script